import { ErrorOutline } from "@mui/icons-material";

const TradeAlertIndicator = () => (
  <ErrorOutline color="error" sx={{ fontSize: "12px", marginRight: 1 }} />
);

export { TradeAlertIndicator };
